import { useMemo } from 'react'
import OnPremAgentClient from './OnPremAgentClient'

const useOnPremAgentClient = (): OnPremAgentClient => {
  return useMemo(() => {
    return new OnPremAgentClient()
  }, [])
}

export default useOnPremAgentClient
